// extracted by mini-css-extract-plugin
export default {"wrap":"aG-z","subtitle":"bG-z","contentWrap":"cG-z","imgWrap":"dG-z","heading":"eG-z","copy":"fG-z"};